import React from 'react';
import { VideoLandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingVideoWatermarkRemoverConfig } from '@/data/landingConfig/landingVideoWatermarkRemoverConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_VideoWatermarkRemover } from './schemaObject';

interface Props {}
const VideoWatermarkRemover: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_VideoWatermarkRemover} />
			<VideoLandingTemplate
				data={landingVideoWatermarkRemoverConfig}
				funnelLinkService={GenerateLandingLinkService.funnelWatermarkRemoverV2()}
			/>
		</>
	);
};

export default VideoWatermarkRemover;
